// Our main CSS
import '../css/app.css'


/**
 * 🦄: Now do your magic.
 */


import { ModuleManager } from './moduleManager'

const moduleManager = new ModuleManager()// Register all modules with their selectors
moduleManager
  .register('.js-nav-item', 'mainNav')
  .register('.js-mobile-menu-toggle', 'mobileNav')
  .register('.js-faqs', 'faq')
  .register('.js-copy-link', 'copyLink')
  .register('.js-references', 'references')
  .register('.js-grants-filter-form', 'grantsFilter')
  .register('.js-news-listing', 'newsListing')
  .register('.js-reports-listing', 'reportsListing')
  .register('.js-search-results', 'searchResults')
  .register('.js-knowledge-library', 'knowledgeLibrary')
  .register('.js-chapter-nav', 'chapterNav')
  .register('.js-video-gallery', 'videoGallery')
  .register('.js-google-chart', 'googleChart')
  .register('.js-custom-table', 'customTable')
  .register('.js-sources-panel-wrapper', 'sourcesPanel')

  .registerAdmin('Faq', 'faq')
  .registerAdmin('GoogleChart', 'googleChart')
  .registerAdmin('CustomTable', 'customTable')

// Initialize modules
moduleManager.init()